import { css } from 'aphrodite';
import { StatusBanner } from '../components/StatusBanner';
import { styleSheet } from './styles';

export const CoffeeSubBar = ({ dialer }: { dialer?: React.ReactNode }) => (
	<div className={css(styleSheet.subBar)}>
		<StatusBanner dialer={dialer} />
	</div>
);
